// extracted by mini-css-extract-plugin
export default {"table":"plantio-atual_table__Fo+yG","oddRow":"plantio-atual_oddRow__4-BkK","evenRowLight":"plantio-atual_evenRowLight__QADrw","nivo-axis":"plantio-atual_nivo-axis__oPPh+"};